import React, { useContext, useState } from "react";
import Select from "react-select";
import { Settings } from "../../../helpers/Contexts";
import * as API from "../../../api";

const ColonCancerScreening = ({ task, values, handleChange }) => {
  const settings = useContext(Settings);
  const initialValue =
    values !== ""
      ? {
          label: values[0].name,
          id: values[0].id,
          quality_measurement_type_id: values[0].quality_measurement_type_id,
        }
      : {
          label: "",
          value: "",
        };
  const options = settings.colon_cancer_screening_options;
  async function postSelectedMeasurement(e) {
    let req = {
      patient_id: task.patient.uid,
      cpr_id: task.cpr.id,
      value: true,
      quality_measurement_type_id: e.quality_measurement_type_id,
    };

    const res = await API.postQualityMeasurement(
      task.cpr.attending_provider
        ? { quality_measurement: { ...req, attending_provider: task.cpr.attending_provider } }
        : { quality_measurement: { ...req } }
    );
    return res;
  }

  async function handleMeasurement(e) {
    task.dispatch({ type: "set_loading", payload: true });
    if (!values) {
      await postSelectedMeasurement(e);
      task.dispatch({ type: "set_current_task", payload: await API.getTaskById(task.id) });
    } else {
      values.forEach((i) => {
        API.deleteQualityMeasurement({
          quality_measurement: {
            patient_id: task.patient.uid,
            cpr_id: task.cpr.id,
            id: i.id,
          },
        });
      });
      await postSelectedMeasurement(e);
      task.dispatch({ type: "set_current_task", payload: await API.getTaskById(task.id) });
    }
  }

  return (
    <div className="screening">
      <label>Colon Cancer Screening</label>
      <span id="from">Select a measurement</span>

      <Select
        defaultValue={initialValue}
        placeholder="Select a measurement"
        options={options}
        onChange={(e) => {
          handleMeasurement(e);
          handleChange(e.label);
        }}
      />
    </div>
  );
};
export default ColonCancerScreening;
